<footer>
  <div class="footer-container">
    <div class="footer-ssn-bar">
      <div class="footer-ssn-item">
        <img src="assets/iconos/logo_SSN_color.png" alt="SSN" style="height: 40px; margin-right: 16px;">
        <div>
          <p style="margin:0;"><strong>Nº de matrícula SSN:</strong> {{perfil?.pas_matricula}}</p>
          <p style="margin:0;"><strong>Departamento de Orientación y Asistencia al asegurado:</strong> 0800-666-8400</p>
          <a href="https://www.argentina.gob.ar/ssn" target="_blank" style="font-size: 15px; color: var(--primary-800); text-decoration: underline;">www.argentina.gob.ar/ssn</a>
        </div>
      </div>
    </div>
    <div class="footer-main-row">
      <div class="footer-main-col logo-col">
        <img *ngIf="perfil" src="{{ perfil.pas_logo_base64_blanco }}" alt="Logo" style="width: 220px; height: auto;">
        <h4 style="margin-top: 20px;">{{perfil?.pas_texto_footer}}</h4>
      </div>
      <div class="footer-main-col menu-col">

        <nav class="footer-menu">
          <a mat-button routerLink="/cotizador">Cotizar</a>
          <a mat-button routerLink="/descarga-poliza">Descargá tu póliza</a>
          <a mat-button routerLink="/preguntas-frecuentes">Preguntas Frecuentes</a>
          <!--<a mat-button routerLink="/siniestros">Siniestros</a>-->
          <!--<a mat-button routerLink="/contactos">Contactos</a>-->
        </nav>

      </div>
      <div class="footer-main-col contact-col">
        <h2>Contacto</h2>
        <p><fa-icon [ngStyle]="{'color': 'var(--accent-500)'}" [icon]="['fas', 'location-dot']"></fa-icon> Dirección: {{perfil?.pas_direccion}}</p>
        <p><fa-icon [ngStyle]="{'color': 'var(--accent-500)'}" [icon]="['fas', 'phone']"></fa-icon> Teléfono: {{perfil?.pas_tel_contacto}}</p>
        <p><fa-icon [ngStyle]="{'color': 'var(--accent-500)'}" [icon]="['fas', 'clock']"></fa-icon> Horario: {{perfil?.pas_horario}}</p>
        <p><fa-icon [ngStyle]="{'color': 'var(--accent-500)'}" [icon]="['fas', 'envelope']"></fa-icon> Email: {{perfil?.pas_email_contacto}}</p>
      </div>
    </div>
  </div>
  <div class="main-footer">
    <div class="footer-content">
      <span>&copy; 2025 Coverit. Todos los derechos reservados.</span>
      <div style="display:flex; align-items:center; gap:12px; margin-left:12px;">
        <span>
          Un servicio de <img src="assets/iconos/arg.png" alt="Proveedor" style="height:50px;">
        </span>


      </div>
    </div>
  </div>
</footer>
